import { ClientError } from './client-error';

export class IncompleteAssessmentReadOnlyError extends ClientError {
  constructor(message?: string) {
    super(message);

    this.name = 'IncompleteAssessmentReadOnlyError';
  }
}
